<template>
  <w-icon-wrapper
    :height='24.347'
    :width='24.347'
    icon-name='work-edit-icon'
    view-box='0 0 24.347 24.347'
  >
    <g
      id='_25_Bearbeiten_Icon'
      data-name='25 Bearbeiten_Icon'
      transform='translate(0.1 0.265)'
    >
      <path
        id='Pfad_55695'
        d='M23,8.315a1,1,0,0,0-1,1V21.982H2v-20H14.666a1,1,0,1,0,0-2H0v24H24V9.315A1,1,0,0,0,23,8.315Z'
        data-name='Pfad 55695'
        fill='currentColor'
        stroke='currentColor'
        stroke-width='0.2'
      />
      <path
        id='Pfad_55696'
        d='M6.12,14.626,4.177,18.8a.8.8,0,0,0,.165.918v0a.8.8,0,0,0,.565.241.77.77,0,0,0,.353-.083l4.11-2.006a.778.778,0,0,0,.214-.154L21.813,5.483l.034-.03,1.476-1.479.008-.008A2.342,2.342,0,0,0,20.01.662l-1.6,1.6c-.012.011-.019.023-.031.034L6.281,14.4A.783.783,0,0,0,6.12,14.626ZM21.161,1.8a.674.674,0,0,1,.494-.206.743.743,0,0,1,.526.226l.01.01a.7.7,0,0,1-.01.99l-.934.933-1.019-1.02.936-.933ZM7.527,15.442,19.081,3.887,20.1,4.9,8.543,16.466l-1.93.941Z'
        data-name='Pfad 55696'
        fill='currentColor'
        stroke='currentColor'
        stroke-width='0.2'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconEdit' };
</script>
